import React from 'react'
import LiteYouTubeEmbed from 'react-lite-youtube-embed'
import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css'

import {
  EuiCard,
  EuiFlexGroup,
  EuiFlexItem,
  EuiText
} from '@elastic/eui'


export default function softwareVideos() {

  return (
    <React.Fragment>
        <EuiFlexGroup gutterSize="l" direction="row" style={{margin: '0 7px'}} >
          <EuiFlexItem>
            <EuiCard
              textAlign="left"
              image={
                <LiteYouTubeEmbed 
                    id="AV2vr5X7Re8"
                    title="Wiederherstellen der Firmware Ihrer INSTAR HD-Kameras"
                    adNetwork={true}
                    poster="maxresdefault" //hqdefault
                    noCookie={true}
                />
              }
              title="Wiederherstellen der Firmware Ihrer INSTAR HD-Kameras"
              footer={
                <EuiText>
                  <p>In diesem Video zeigen wir Ihnen wie Sie über die serielle Schnittstelle Ihre INSTAR HD IP Kamera wiederbeleben können sofern Sie ein fehlerhaftes Firmwareupdate hatten weil z.B. die Stromverbindung unterbrochen wurde.</p>
                  <p>Im Video zeigen wir Schritt für Schritt wie Sie die vorhandene Firmware durch die aktuelle überspielen können.</p>
                </EuiText>
              }
            />
          </EuiFlexItem>
        </EuiFlexGroup>
    </React.Fragment>
  );
}